import React from "react"

const GradientBannerContainer = ({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) => {
  const divStyle: React.CSSProperties = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "39px",
    width: "100%",
    alignSelf: "stretch",
    background: "linear-gradient(98deg, #6C63FF 0%, #B592FF 100%)",
  }

  return (
    <div className="flex flex-col justify-center">
      <div
        style={divStyle}
        className={
          "xl:px-52 py-[20px] md:py-[78px] lg:px-36 md:px-36 sm:px-5 px-0  mx-auto " +
          className
        }
      >
        {children}
      </div>
    </div>
  )
}

export default GradientBannerContainer
